import { ROUTER_URL } from '../router/constants';
/**
 * Routes where Datadog RUM and Session Replay must not record (CNA-1608).
 * Add a path here to exclude it: RUM init, the beforeSend filter, the replay guard and the shared
 * Outlet all read this one list.
 */
export var RUM_EXCLUDED_ROUTES = [
    ROUTER_URL.Users,
    ROUTER_URL.Hubspot,
    // Genesys OAuth implicit-grant callback (genesys-ui only): the access token is in the URL hash.
    '/callback',
];
/** Query params whose values are our own IDs or enums, kept verbatim in RUM URLs. Anything else is redacted unless numeric. */
export var RUM_SAFE_QUERY_PARAMS = [
    'step',
    'queueId',
    'copyScenarioId',
    'displayMode',
    'uniqueId',
    'chartLobId',
    'chartSubLobId',
    'chartQueueId',
    'month',
    'startMonth',
    'endMonth',
    'selectedDate',
    'configured',
    // Static enums on API calls
    'view',
    'lang',
    'libraries',
];
/** Path segments whose following segment is always redacted (e.g. `/phoneVerificationCode/{phone}`). */
export var RUM_REDACTED_PATH_PARENTS = ['phoneVerificationCode'];
/**
 * Spread onto an `<input>` whose value can only be a number, a date or an on/off state, so Session Replay
 * records it instead of masking it. Never put this on a free-text input.
 */
export var RUM_READABLE_INPUT_PROPS = { 'data-dd-privacy': 'allow' };
/** Static UI text that is hard-coded rather than in the locale files, kept readable in replay and action names. */
export var RUM_EXTRA_ALLOWED_TEXT = [
    'N/A',
    'ERR',
    'TOTAL',
    'X',
    'sec',
    // MUI table pagination
    'Rows per page:',
    '{{from}}–{{to}} of {{count}}',
];
// React Router matches paths case-insensitively, so compare lower-cased.
export var isRumExcludedPath = function (pathname) {
    var path = pathname.toLowerCase();
    return RUM_EXCLUDED_ROUTES.some(function (route) {
        var prefix = route.toLowerCase();
        return path === prefix || path.startsWith("".concat(prefix, "/"));
    });
};
